@if (breadCrumbStateService.breadcrumbsState$ | async; as breadcrumbState) {
  @if (breadcrumbState === VerticalNavState.FOLDER_VIEW) {
    <folder-breadcrumbs></folder-breadcrumbs>
  }
  @if (breadcrumbState === VerticalNavState.LICENSE_MANAGEMENT_VIEW) {
    <licensing-breadcrumbs></licensing-breadcrumbs>
  }
  @if (breadcrumbState === VerticalNavState.ARCHIVE_VIEW) {
    <archive-breadcrumbs></archive-breadcrumbs>
  }
  @if (breadcrumbState === VerticalNavState.USER_SETTINGS) {
    <settings-breadcrumbs></settings-breadcrumbs>
  }
}
